<div class="container">
  <div class="wrapper">
    <div *ngIf="componentState === ComponentState.Initializing || isWalletBalanceSufficient()">
      <div class="header no-margin">
        <p class="head-text text-color-finzy-blue">Create new portfolio</p>
      </div>
      <div class="text-center">
        <p>Minimum portfolio creation amount is
          <strong style="color: #0d3ab3;">
            <app-indian-currency-formatter
              [amount]="getMinimumPortfolioCreationAmount()"></app-indian-currency-formatter>
          </strong> and it
          should be in multiples of <strong>
            <app-indian-currency-formatter [amount]="getInvestmentDenomination()"></app-indian-currency-formatter>
          </strong>.
        </p>
      </div>
      <div class="row">
        <div class="wallet-balance-section col-xs-12 col-md-offset-3 col-md-8">
          <span>Amount available to invest:</span>
          <div class="visible-xs"></div>
          <app-horizontal-loader
            *ngIf="componentState === ComponentState.Initializing"></app-horizontal-loader>
          <span *ngIf="componentState !== ComponentState.Initializing" class="available-amount">
                        <app-indian-currency-formatter
                          [amount]="getAmountAvailableToInvest()"></app-indian-currency-formatter>
                        <app-tooltip placement="bottom">
                            <i class="infoIcon material-icons" trigger>info_outline</i>
                            <div content style="width: 70vw; max-width: 300px">
                                <div class="row">
                                    <p class="col-xs-12">
                                        <span class="col-xs-7 text-left">Wallet Balance: </span>
                                        <strong class="text-right"><app-indian-currency-formatter
                                          [amount]="getWalletBalance()"></app-indian-currency-formatter></strong>
                                    </p>
                                </div>
                                <hr>
                                <div class="row">
                                    <p class="col-xs-12">
                                        <span class="col-xs-7 text-left">Current Principal Outstanding: </span>
                                      <strong class="text-right"><app-indian-currency-formatter
                                        [amount]="getPrincipalOutstanding()"></app-indian-currency-formatter></strong>
                                    </p>
                                </div>
                                <div class="row">
                                    <p class="col-xs-12">
                                        <span class="col-xs-7 text-left">RBI Limit for Principal Outstanding: </span>
                                      <strong class="text-right"><app-indian-currency-formatter
                                        [amount]="configService.getMaximumInvestmentLimit()"></app-indian-currency-formatter></strong>
                                    </p>
                                </div>
                                <hr>
                                <div class="row">
                                    <p class="col-xs-12">
                                        <span class="col-xs-7 text-left">Amount available to invest: </span>
                                      <strong class="text-right"><app-indian-currency-formatter
                                        [amount]="getAmountAvailableToInvest()"></app-indian-currency-formatter></strong>
                                    </p>
                                </div>
                            </div>
                        </app-tooltip>
                    </span>
                    <span class="add-money" (click)="goToWallet()">
                      Add Money to Wallet
                    </span>
        </div>
      </div>
      <form [formGroup]="formGroup">
        <div class="row form-top mb-4">
          <div class="text-center">
            <div class="form-header">Enter investment amount</div>
            <mat-form-field class="mb-3">
              <span matPrefix>₹&nbsp;</span>
              <input matInput floatLabel="true" maxlength="10" type="number"
                     formControlName="portfolioAmount"
                     step="1000"
                     class="portfolio-amount">
              <mat-error>{{getErrorMessage(formGroup.controls['portfolioAmount'])}}</mat-error>
              <mat-hint align="end" *ngIf="componentState === ComponentState.Ready">
                <app-indian-currency-formatter
                  [amount]="getAmountRemainingToInvest(formGroup.controls['portfolioAmount'].value)"></app-indian-currency-formatter>
                left to invest
              </mat-hint>
            </mat-form-field>
          </div>
          <div class="row lender-investment-div" *ngIf="getInvestmentAmountInfoMessage()">
            <p class="lender-investment-text">{{getInvestmentAmountInfoMessage()}}</p>
          </div>
        </div>
        <div class="row">
          <div class="text-justify">
            <mat-checkbox style="display: inline;" formControlName="consent"></mat-checkbox>
            <div class="lender-consent-text" style="display: inline; color: #4a4a4a">
              I, hereby confirm that I have not invested more than ₹50,00,000 across all the P2P platforms in India, including
              www.finzy.com and hereby undertake to inform finzy if my aggregate exposure from investing, across all the P2P platforms in
              India, at any point of time is equivalent to ₹50,00,000, and understand and agree that finzy shall be entitled to take any
              and all actions as it may deem fit.
              <br/>

              I, hereby also agree that as and when my investment across all the P2P platforms in India including www.finzy.com exceed
              ₹10,00,000, I will provide finzy a net-worth certificate from a practicing Chartered Accountant in the
              <a [href] ="getInvestorNetworthCertificateUrlByName('investorNetworthCertificate')">attached format</a>
              certifying that I have net-worth of more than ₹50,00,000.
              <br/>

              I, hereby also confirm that I have understood all the risks associated with the lending transactions and finzy does not
              assure return of principal/payment of interest and there exists a likelihood of loss of the entire principal in case of
              default by a borrower.

              <br/>
                I, hereby confirm to the <a href="https://finzy.com/terms" target="_blank" rel="noopener noreferrer">terms and conditions</a>
            </div>
          </div>
        </div>
        <br>
        <div *ngIf="this.isPreFlexUser" class="row">
          <div class="text-justify">
            <mat-checkbox style="display: inline;" formControlName="consent1"></mat-checkbox>
            <div class="lender-consent-text" style="display: inline; color: #4a4a4a">
                I, hereby confirm that i have understood following points about the current investment portfolio (Finzy Flex - Pre Launch Investment): <br>
                - Investor Rate of Return mentioned for the investment product is an indicative simple interest rate and Bridge Fintech does not guarantee rate of return or return of principal amount.<br>
                - Bridge Fintech will earn differential in interest between the interest rate paid by the borrower and Investor Rate of Return.<br>
                - Investment portfolios must be auto, bolt or reinvest portfolios.<br>
                - Investment preferences on borrower rating, reinvestment and bolt mode will be pre selected and Bridge Fintech may change these preferences without any consent.<br>
                - Monthly periodic cashflow and payment of final maturity amount is offered by Bridge Fintech on best effort basis and might be delayed for operational or other reasons.<br>
                - Bridge Fintech reserves the right to assign any or all loans in my investment portfolios to other lenders at any time. <br>
                - Numbers for principal outstanding, interest, reinvest, wallet transfers, etc. communicated through the dashboard, reports, passbook, interest certificate, email and sms notifications will not align with the actual returns offered in the current investment portfolio (Finzy Flex - Pre Launch Investment).<br>
                - I need to communicate my preference of A. regular monthly cashflow or B. interest to be paid with maturity proceeds at the time of investment. Bridge Fintech may not allow change of this preference at a later date. Such preference will be common across all portfolios (Finzy Flex - Pre Launch Investment) for this pre launch investment opportunity.<br>
            </div>
          </div>
        </div>
        <div class="create-portfolio-section">
          <div>
            <button mat-flat-button class="primary no-text-transform" type="button" (click)="onFinzyProOptionClicked(formGroup)"
                    [disabled]="formGroup.invalid">
              CREATE finzyPRO+ PORTFOLIO
            </button>
          </div>
          <div>
            <strong>OR</strong>
          </div>
          <div>
            Although our finzyPRO+ is crafted to give you the best returns, you could also choose to use our
            <br/>
            <a (click)="onManualInvestOptionClicked(formGroup)"
               class="text-color-finzy-blue bold"
               [class.disabled-link]="formGroup.invalid">
              manual option</a>.
          </div>
        </div>
      </form>
    </div>
  </div>
  <div *ngIf="componentState === ComponentState.Ready && !isWalletBalanceSufficient()">
    <div class="header no-margin">
      <p class="head-text text-color-finzy-blue">Insufficient Wallet Balance</p>
    </div>
    <div class="rectangle">
      <p class="amount-available">Amount available in Wallet: <span class="money">
          <strong>
            <app-indian-currency-formatter [amount]="getAmountAvailableToInvest()"></app-indian-currency-formatter>
          </strong>
        </span>
      </p>
    </div>
    <span *ngIf="!isWalletBalanceSufficientForFirstPortfolioCreation(); else inSufficientMinInvestment" class="finzy-red">
      A minimum of
      <strong>
        <app-indian-currency-formatter [amount]="getMinimumWalletBalanceForInitialPortfolio()"></app-indian-currency-formatter>
      </strong>
      is required to create your first portfolio. Please update your wallet.
    </span>
    <ng-template #inSufficientMinInvestment>
      Looks like there are insufficient funds in your wallet. A minimum of
      <strong>
        <app-indian-currency-formatter [amount]="getMinimumPortfolioCreationAmount()"></app-indian-currency-formatter>
      </strong>
      is required in your wallet to keep investing. Please transfer more funds to continue investing.
    </ng-template>
    <br><br>
    Here are the <a style="color: #0d3ab3;text-decoration: none;cursor: pointer;" (click)="goToWallet()">details</a>
    of how you can
    transfer your funds.
    <br><br>
    If you need assistance you can find help here
    <a target="_blank" style="color: #0d3ab3;text-decoration: none;" [routerLink]="['/faq']">FAQs.</a>
    You could even call us on 9341 300 300. We are always happy to help!
    <div class="rectangle-btn">
      <button class="add-money-btn" (click)="goToWallet()">
        ADD MONEY
      </button>
    </div>
  </div>
</div>
